export const config = {
    staging: "https://pupstaging-default.us-east-2.elasticbeanstalk.com/users/api/profile/",
    production: "https://api.aboundparenting.com/users/v2/api/profile/",
    appUrl: 'https://apps.apple.com/us/app/abound-parenting/id1444991990',
    playStoreUrl: 'https://play.google.com/store/apps/details?id=com.pup.reading'
}